export default {

    namespaced: true,

    state: {
        operation: null,
        form: {
            model: {
                id: null,
                companyId: null,
                departmentId: null,
                parentId: null,
                name: null,
                status: '1',
                leaderId: null,
                syncFromShr: false,

                createUserId: null,
                createTime: null,
                lastUpdateUserId: null,
                lastUpdateTime: null,

                orgId: null,
                parentOrgId: null,
            },
        },
    },

    getters: {

    },

    mutations: {
        setOperation(state, operation) {
            state.operation = operation;
        },
        setFormModel(state, formModel) {
            state.form.model = formModel;
        },
    },

    actions: {

    },

}